import produce from 'immer';

import {
  FETCH_POST_AUTH_NOTIFICATIONS,
  FETCH_POST_AUTH_NOTIFICATIONS_FAILURE,
  FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS,
  RESET_POST_AUTH_NOTIFICATIONS,
  SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN,
  SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS,
  SET_PRE_AUTH_NOTIFICATIONS,
} from './constants';
import { CHANGE_SELECTED_LOAN, RESET_USER_STATE } from '../Main/constants';

export const initialState = {
  error: false,
  isDesktopNotificationsModalOpen: false,
  loading: false,
  notificationsModalAutoOpened: [],
  postAuthNotifications: {},
  preAuthNotifications: {},
};

/* eslint-disable consistent-return, default-case, no-param-reassign */
const notificationsReducer = produce((draft, { payload, type }) => {
  switch (type) {
    case CHANGE_SELECTED_LOAN: {
      return {
        ...initialState,
        notificationsModalAutoOpened: draft.notificationsModalAutoOpened,
      };
    }
    case FETCH_POST_AUTH_NOTIFICATIONS: {
      draft.error = false;
      draft.loading = true;
      break;
    }
    case FETCH_POST_AUTH_NOTIFICATIONS_FAILURE: {
      const { error } = payload;
      draft.loading = false;
      draft.error = error;
      break;
    }
    case FETCH_POST_AUTH_NOTIFICATIONS_SUCCESS: {
      const { notifications, notificationsModalAutoOpened } = payload;
      draft.loading = false;
      draft.postAuthNotifications = notifications;
      if (notificationsModalAutoOpened.length) {
        draft.notificationsModalAutoOpened = notificationsModalAutoOpened;
      }
      break;
    }
    case RESET_POST_AUTH_NOTIFICATIONS: {
      draft.postAuthNotifications = initialState.postAuthNotifications;
      break;
    }
    case RESET_USER_STATE: {
      return initialState;
    }
    case SET_DESKTOP_NOTIFICATIONS_MODAL_OPEN: {
      const { value } = payload;
      draft.isDesktopNotificationsModalOpen = value;
      break;
    }
    case SET_NOTIFICATIONS_MODAL_AUTO_OPENED_LOANS: {
      const { loanNumber } = payload;
      if (!draft.notificationsModalAutoOpened.includes(loanNumber)) {
        draft.notificationsModalAutoOpened.push(loanNumber);
      }
      break;
    }
    case SET_PRE_AUTH_NOTIFICATIONS: {
      const { preAuthNotifications } = payload;
      draft.preAuthNotifications = preAuthNotifications;
      break;
    }
  }
}, initialState);

export default notificationsReducer;
